import { apis2, apis } from '.';
import http from './http';

export default class OpenConsoleApi { 
  static consoleConfigData () {
    return http.post(apis2.OpenConsoleApi.consoleConfigData, { })
  }

  static getConsoleStyle (providerId: number) {
    return http.get(apis.get_console_style, { providerId })
  }

  static getPermissions (roleId: number) {
    return http.get(apis.permissions_list, { roleId })
  }
}
